import { render, staticRenderFns } from "./ReadLayout.vue?vue&type=template&id=41981263&scoped=true&"
var script = {}
import style0 from "./ReadLayout.vue?vue&type=style&index=0&id=41981263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41981263",
  null
  
)

export default component.exports